import React, { useState } from 'react';
import { HeightOutlined } from '@mui/icons-material';
import BaseSidebarPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/BaseSidebarPanel';
import ColorInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/ColorInput/index';
import SliderInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/SliderInput';
import MultiStylePropertyPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/style-inputs/MultiStylePropertyPanel';
import DividerBlock from './index';
export default function DividerSidebarPanel({ data, setData }) {
    var _e, _t, _y, _10;
    const [, setErrors] = useState(null);
    const updateData = (d) => {
        const res = DividerBlock.schema.safeParse(d);
        if (res.success == true) {
            setData(res.data);
            setErrors(null);
        }
        else {
            setErrors(res.error);
        }
    };
    const lineColor = (_t = (_e = data.props) === null || _e === void 0 ? void 0 : _e.lineColor) !== null && _t !== void 0 ? _t : DividerBlock.defaultData.props.lineColor;
    const lineHeight = (_10 = (_y = data.props) === null || _y === void 0 ? void 0 : _y.lineHeight) !== null && _10 !== void 0 ? _10 : DividerBlock.defaultData.props.lineHeight;
    return (React.createElement(BaseSidebarPanel, { title: "Divider block" },
        React.createElement(ColorInput, { label: "Color", defaultValue: lineColor, onChange: (lineColor) => updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { lineColor }) })) }),
        React.createElement(SliderInput, { label: "Height", iconLabel: React.createElement(HeightOutlined, { sx: { color: 'text.secondary' } }), units: "px", step: 1, min: 1, max: 24, defaultValue: lineHeight, onChange: (lineHeight) => updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { lineHeight }) })) }),
        React.createElement(MultiStylePropertyPanel, { names: ['backgroundColor', 'padding'], value: data.style, onChange: (style) => updateData(Object.assign(Object.assign({}, data), { style })) })));
}
//# sourceMappingURL=DividerSidebarPanel.js.map